export enum SurveySendTimeOptions {
  ONE_MINUTE = "1 minute",
  FIVE_MINUTES = "5 minutes",
  THIRTY_MINUTES = "30 minutes",
  ONE_HOUR = "1 hour",
  TWO_HOURS = "2 hours",
  THREE_HOURS = "3 hours",
  FOUR_HOURS = "4 hours",
  SIX_HOURS = "6 hours",
  NINE_HOURS = "9 hours",
  TWELVE_HOURS = "12 hours",
  ONE_DAY = "1 day",
  TWO_DAYS = "2 days",
  THREE_DAYS = "3 days",
  SEVEN_DAYS = "7 days",
}

export type CsatSurveySendTime = SurveySendTimeOptions;
export const CSAT_SURVEY_SEND_TIME_OPTIONS: readonly SurveySendTimeOptions[] =
  Object.values(SurveySendTimeOptions);

export enum CsatSurveyMethod {
  REDO_CHAT = "redoChat",
  EMAIL = "email",
}

export const CSAT_SURVEY_METHODS: readonly CsatSurveyMethod[] =
  Object.values(CsatSurveyMethod);
